import { render, staticRenderFns } from "./ForumResponseBodyTextOutputMention.vue?vue&type=template&id=bf39d8b0&scoped=true"
import script from "./ForumResponseBodyTextOutputMention.vue?vue&type=script&lang=js"
export * from "./ForumResponseBodyTextOutputMention.vue?vue&type=script&lang=js"
import style0 from "./ForumResponseBodyTextOutputMention.vue?vue&type=style&index=0&id=bf39d8b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf39d8b0",
  null
  
)

export default component.exports